import { jsx as _jsx } from "react/jsx-runtime";
export default function ChevronRightIcon(props) {
    return (_jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...props, children: _jsx("path", { d: "M8.29492 16.59L12.8749 12L8.29492 7.41L9.70492 6L15.7049 12L9.70492 18L8.29492 16.59Z", fill: "currentColor" }) }));
}
